import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import React from 'react';

const DeleteAlert = ({
  isOpen,
  cancelRef,
  onClose,
  isDeleting,
  header = 'Delete?',
  body = `Are you sure? If you proceed with the deletion, it'll be gone
forever.`,
  onDeleteItem,
  deleteText = 'Delete',
}) => {
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      blockScrollOnMount={false}
      closeOnOverlayClick={isDeleting ? false : true}
      closeOnEsc={isDeleting ? false : true}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {header}
          </AlertDialogHeader>

          <AlertDialogBody>{body}</AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              variant={'outline'}
              onClick={onClose}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              bg={'red.400'}
              _hover={{
                color: 'red.400',
                bg: 'transparent',
              }}
              onClick={onDeleteItem}
              ml={3}
              isLoading={isDeleting}
            >
              {deleteText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default DeleteAlert;
